module.exports = __webpack_public_path__ + "media/images/mobile/Slider7-a20a98835e414800e12c0d368188cba8.png";